import LBox from "@components/LBox";
import LIcon from "@components/LIcon";
import LText from "@components/LText";
import { MUSIC_ACCESS_FLOW_COPY } from "@libs/shared-ui";
import { theme } from "@theme";

/** Members-only music has no price: "Members only" stands in its place
 *  (LIS-1156), in the row the price takes. */
const Badge = () => (
  <LBox flexDirection="row" alignItems="center" gap="s1_5">
    <LIcon
      colors={{ color: theme.colors.whiteTranslucent50 }}
      name="lock_locked"
      size={16}
    />
    <LText variant="Body/B1/Medium" color="white">
      {MUSIC_ACCESS_FLOW_COPY.membersOnly}
    </LText>
  </LBox>
);

/** Whose fan club it is for, as the Live Link's sheet says it. */
const Line = ({ clubArtistName }: { clubArtistName: string }) => (
  <LText variant="Body/B1/Regular" color="white" opacity={0.85}>
    {MUSIC_ACCESS_FLOW_COPY.membersOnlyLine(clubArtistName)}
  </LText>
);

export default { Badge, Line };
